import { SourceName } from "../../../../types"
import type { ApiLabPerfSalesContribution } from "../../../laboratorySales/contribution"

/**
 * UPP ids below are intentional:
 * - existing ids match the UPP dataref mock
 *   (libs/adherent-domain/src/mocks/data/dataRef.ts) so `getUppName` resolves a
 *   real name
 * - `id: null` is on purpose too: it stands for the aggregated bucket displayed
 *   as "Autres Pharmacies"
 */
export const labPerfSalesContributionFake = (): ApiLabPerfSalesContribution => ({
  periodStartDate: "2026-01-01",
  periodEndDate: "2026-07-20",
  sources: [SourceName.SANTESTAT],
  sales: {
    mainStat: 28200.0,
    evolution: 6.82,
  },
  growthContribution: 1800.0,
  growthDrivers: {
    sales: {
      mainStat: 24200.0,
      evolution: 43.2,
    },
    growthContribution: 7300.0,
    upps: [
      {
        id: 1, // dataref: "Power UPP"
        sales: { mainStat: 15000.0, evolution: 50.0 },
        growthContribution: 5000.0,
        growthContributionWeight: 68.49,
      },
      {
        id: 3, // dataref: "GIVE UPP"
        sales: { mainStat: 8000.0, evolution: 33.33 },
        growthContribution: 2000.0,
        growthContributionWeight: 27.4,
      },
      {
        id: 92, // dataref: "NicoUpp" — zeroed values on purpose
        sales: { mainStat: 0, evolution: 0 },
        growthContribution: 0,
        growthContributionWeight: 0,
      },
      {
        id: null, // no dataref match expected: "Autres Pharmacies"
        sales: { mainStat: 1200.0, evolution: 33.33 },
        growthContribution: 300.0,
        growthContributionWeight: 4.11,
      },
    ],
  },
  growthDetractors: {
    sales: {
      mainStat: 4000.0,
      evolution: -57.89,
    },
    growthContribution: -5500.0,
    upps: [
      {
        id: 12, // dataref: "L'UPP PPP"
        sales: { mainStat: 3000.0, evolution: -57.14 },
        growthContribution: -4000.0,
        growthContributionWeight: 72.73,
      },
      {
        id: 77, // dataref: "Test UPP N1"
        sales: { mainStat: 1000.0, evolution: -60.0 },
        growthContribution: -1500.0,
        growthContributionWeight: 27.27,
      },
    ],
  },
})
